import React from "react";
import {connect} from 'react-redux'

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import RecordVoiceOver from "@material-ui/icons/RecordVoiceOver";
import Email from "@material-ui/icons/Email";
import KeyIcon from "@material-ui/icons/VpnKey";
import PhoneIcon from "@material-ui/icons/Phone";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";

// core components
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import PictureUpload from "components/CustomUpload/PictureUpload.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";


// @material-ui/core components
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import LinearProgress from '@material-ui/core/LinearProgress';

//users
import {
  userEdit,
  usersave,
  myUserFetch,
  usersFetchHelper,
  userUpdatePassword
} from 'actions/users'

import {
  ibFilter,
  ibsFetch
} from 'actions/ibs'

import {
  danger,
  success,
} from 'actions/notification'

import * as  roles from 'constants/userPermissions'
//styles
import styles from "assets/jss/material-dashboard-pro-react/views/form";
import {entityPermissions as entityPermissionsEnum} from 'enums'
class Form extends React.Component {
  state={
    form:{
      userId:0,
      login:'',
      phoneNumber:'',
      email:'',
      name:'',
      password:'',
      role:'',
      linkedIbId: '',
      entityPermissions: []
    },
    oldUser: {},
    showPermEntities: false,
    allUsers: []
  }
  componentDidMount(){
    this.props.fetchAllUsers().then((users)=> {
      this.setState({...this.state, allUsers: users})
    })
    this.props.ibFilter({size: 100000,sort:{firstName: 'asc'}})
    this.props.ibsFetch()
    if (this.props.match.params.id) {
      this.props.fetch(this.props.match.params.id)
            .then(e=> {
              this.setState({
                ...this.state,
                form:{
                  ...e,
                  linkedIbId: (e.linkedIbId)? e.linkedIbId :'',
                  role: Object.keys(roles).find(k=> e.permissions.includes(k)),
                  entityPermissions: Object.keys(entityPermissionsEnum).filter(k=> e.permissions.includes(k))
                },
                oldUser: this.props.user,
                showPermEntities: e.permissions.includes('COMMON_USER') || e.permissions.includes('CUSTOMER_SUPPORT_USER')
              })
            });
    }

  }
  permissionsValid(){
    const role = this.state.form.role
    const userId = this.props.match.params.id || ''
    if(role === 'IB' && !this.state.form.linkedIbId){
      this.setState({
        linkedIbValidationError: 'Please select IB to link the user!',
        emailValidationError: null,
        loginValidationError: null
      })
      return false
    } else if(this.state.allUsers.filter((u) => u.userId.toString() !== userId).find((u)=> u.login === this.state.form.login)){ 
      this.setState({
        loginValidationError: 'This login name already exists!',
        emailValidationError: null,
        linkedIbValidationError: null
      })
      return false
    } else if(this.state.allUsers.filter((u) => u.userId.toString() !== userId).find((u)=> u.email === this.state.form.email)){ 
      this.setState({
        emailValidationError: 'This email already exists!',
        linkedIbValidationError: null,
        loginValidationError: null
      })
      return false
    } else {
      this.setState({
        linkedIbValidationError: null,
        emailValidationError: null,
        loginValidationError: null
      })
      return true
    }
  }

  submit(e){

    if(e.preventDefault)
      e.preventDefault();

    if(!this.permissionsValid()) {
      return false
    }
    
    let data = {...this.state.form}
    data.permissions = [this.state.form.role, ...this.state.form.entityPermissions]
    data.ibId = !data.permissions.includes('IB') ? null : data.linkedIbId
    delete data.linkedIbId
    delete data.entityPermissions
    delete data.role
    const editMode = this.props.match.params.id

    this.props.edit(this.state.form.userId,data)

    if(this.state.form.password && editMode){
      this.props.userUpdatePassword(this.state.form.userId)
    }

    this.props.save(this.state.form.userId).then(e1=> {

      this.props.history.goBack()
      this.props.success(e1.name+ ' '+(e1.userId?'Edited':'Added')+'!',5);

    }).catch(e1=>{
        this.props.danger(e1+'',30);
    })

  }

  change(event, name){
    let showPermEntities = this.state.showPermEntities
    if(name === 'role'){
      showPermEntities = event.target.value === 'COMMON_USER' || event.target.value === 'CUSTOMER_SUPPORT_USER'
    }
    this.setState({
      ...this.state,
      form:{
        ...this.state.form,
        [name]:event.target.value
      },
      showPermEntities
    })
  }
  
  render() {
    const {classes, isFetching, ibs, auth}=this.props;
    const editMode = this.props.match.params.id;
    //if current user is not admin he can create only users that are not admins
    const filteredRoles = auth.permissions.includes('NOTADMIN')
      ? Object.keys(roles).filter((x) => x !== 'ADMIN')
      : Object.keys(roles)
    return (
          <GridContainer justify="center">
            <GridItem xs={12} sm={8}>
            <Card>
            <CardBody>
            {(isFetching)
            ?<LinearProgress/>
            :<form
              onSubmit={this.submit.bind(this)}
            >
              <GridContainer justify="center">
                <GridItem xs={12} sm={12}>
                  <h4 className={classes.infoText}>
                    Complete information
                  </h4>
                </GridItem>
                  <GridItem xs={12} sm={4}>
                    <PictureUpload />
                  </GridItem>
                  <GridItem xs={12} sm={6}>
                    <CustomInput labelText={
                        <span>
                          Login <small>(required)</small>
                        </span>
                      }
                      id="login"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        value:this.state.form.login,
                        required:true,
                        onChange: event => this.change(event, "login"),
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            className={classes.inputAdornment}
                          >
                            <Face className={classes.inputAdornmentIcon} />
                          </InputAdornment>
                        )
                      }}
                    />
                    {this.state.loginValidationError && (
                      <div style={{display: 'block', color:'red', paddingBottom: '10px'}}>
                        <small>{this.state.loginValidationError}</small>
                      </div>
                    )}
                    <CustomInput labelText={
                        <span>
                          Email <small>(required)</small>
                        </span>
                      }
                      id="email"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        value:this.state.form.email,
                        type:'email',
                        required:true,
                        onChange: event => this.change(event, "email"),
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            className={classes.inputAdornment}
                          >
                            <Email className={classes.inputAdornmentIcon} />
                          </InputAdornment>
                        )
                      }}
                    />
                    {this.state.emailValidationError && (
                      <div style={{display: 'block', color:'red', paddingBottom: '10px'}}>
                        <small>{this.state.emailValidationError}</small>
                      </div>
                    )}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12} lg={10}>
                    <CustomInput
                      labelText={
                        <span>
                          Name <small>(required)</small>
                        </span>
                      }
                      id="name"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        onChange: event => this.change(event, "name"),
                        required:true,
                        value:this.state.form.name,
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            className={classes.inputAdornment}
                          >
                            <RecordVoiceOver className={classes.inputAdornmentIcon} />
                          </InputAdornment>
                        )
                      }}
                    />
                    <CustomInput
                      labelText={
                        <span>
                          Phone <small>(required)</small>
                        </span>
                      }
                      id="phoneNumber"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        onChange: event => this.change(event, "phoneNumber"),
                        required:true,
                        type:'phone',
                        value:this.state.form.phoneNumber,
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            className={classes.inputAdornment}
                          >
                            <PhoneIcon className={classes.inputAdornmentIcon} />
                          </InputAdornment>
                        )
                      }}
                    />

                    <CustomInput
                      labelText={
                        <span>
                          Password <small>(required)</small>
                        </span>
                      }
                      id="password"
                      formControlProps={{
                        fullWidth: true
                      }}
                      value={this.state.form.password}
                      inputProps={{
                        onChange: event => this.change(event, "password"),
                        required:(editMode)? false:true,
                        type:'password',
                        
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            className={classes.inputAdornment}
                          >
                            <KeyIcon className={classes.inputAdornmentIcon} />
                          </InputAdornment>
                        )
                      }}
                    />

                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                      style={{paddingBottom: '17px'}}
                    >
                      <InputLabel
                        htmlFor="simple-select"
                        className={classes.selectLabel}
                      >
                        Select Access
                      </InputLabel>
                      <Select
                        native
                        required={true}
                        value={this.state.form.role}
                        MenuProps={{ className: classes.selectMenu }}
                        classes={{ select: classes.select }}
                        inputProps={{
                          onChange:event => this.change(event, "role"),
                          id: 'role'
                        }}>
                          <option value="" disabled></option>
                          {filteredRoles.map((e)=>(
                            <option key={e} value={e}>{roles[e]}</option>
                          ))}
                      </Select>
                    </FormControl>
                    
                    {this.state.showPermEntities && (
                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                        style={{paddingBottom: '17px'}}
                      >
                        <InputLabel
                          htmlFor="perms"
                          className={classes.selectLabel}
                        >
                          Permissions
                        </InputLabel>
                        <Select
                          multiple
                          value={this.state.form.entityPermissions}
                          MenuProps={{ className: classes.selectMenu }}
                          classes={{ select: classes.select }}
                          inputProps={{
                            onChange:event => this.change(event, "entityPermissions"),
                            id: "perms"
                          }}>
                          {Object.keys(entityPermissionsEnum).map((e)=>(
                            <MenuItem
                              key={e}
                              classes={{
                                root: classes.selectMenuItem,
                              }}
                              value={e}>
                              {entityPermissionsEnum[e]}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                    {this.state.form.role === 'IB' && (
                    <FormControl
                    fullWidth
                    className={classes.selectFormControl}
                    style={{paddingBottom: '17px'}}
                    >
                      <InputLabel
                        htmlFor="linkedIbId"
                        className={classes.selectLabel}
                      >
                        Linked Ib <small>{auth.permissions.includes('NOTADMIN') ? '(required)' : ''}</small>
                      </InputLabel>
                      <Select
                        native
                        id="linkedIbId"
                        name="linkedIbId"
                        required={auth.permissions.includes('NOTADMIN')}
                        value={this.state.form.linkedIbId}
                        MenuProps={{ className: classes.selectMenu }}
                        classes={{ select: classes.select }}
                        inputProps={{
                          onChange:event => this.change(event, "linkedIbId"),
                          id: "linkedIbId",
                          name: "linkedIbId"
                        }}>
                        <option value="" disabled></option>
                        {Object.values(ibs).map(item => 
                          <option key={item.ibId} value={item.ibId}>{item.name+' '+item.lastName+' ('+item.ibId+')'}</option>
                        )}
                      </Select>
                      {this.state.linkedIbValidationError && (
                        <div style={{display: 'block', color:'red', paddingBottom: '10px'}}>
                          <small>{this.state.linkedIbValidationError}</small>
                        </div>
                      )}
                    </FormControl>
                    )}
                    
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12} lg={10}>
                    <Button type="submit"  className={classes.submit} color="success">Submit</Button>
                  </GridItem>
              </GridContainer>
              </form>
            }
              </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
    );
  }
}
const mapStateToProps=( state,props )=>({
  isFetching:state.users.isFetching,
  user:state.users.list[props.match.params.id],
  ibs: state.ibs.list,
  auth: state.auth
})
const mapDispatchToProps=( dispatch )=>({
  fetch:(id,data)=>dispatch(myUserFetch(id,data)),
  edit:(id,data)=>dispatch(userEdit(id,data)),
  save:(id)=>dispatch(usersave(id)),
  danger:(text,sec)=>dispatch(danger(text,sec)),
  success:(text,sec)=>dispatch(success(text,sec)),
  ibsFetch: () => dispatch(ibsFetch()),
  ibFilter: (filter) => dispatch(ibFilter(filter)),
  fetchAllUsers: () => dispatch(usersFetchHelper()),
  userUpdatePassword: (id) => dispatch(userUpdatePassword(id))
})
export default withStyles({styles})(connect(mapStateToProps,mapDispatchToProps)(Form));



// WEBPACK FOOTER //
// ./src/views/Users/Form.jsx